<template>
  <div class="visit-record">
    <div class="visit-record-content">
      <el-row>
        <el-col :span="11">
          <div class="visit-record-content-item">
            <span class="title">日期:</span>
            <span class="value">{{ drawerData.visitTimeStart }}</span>
          </div>
        </el-col>
        <el-col :span="11">
          <div class="visit-record-content-item">
            <span class="title">地点:</span>
            <span class="value">{{
              drawerData.visitArea + "-" + drawerData.visitAddress
            }}</span>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <div class="visit-record-content-item">
            <span class="title">客户参加人员:</span>
            <span class="value" style="width: 130px" v-if="flag"
              ><input v-model="drawerData.visitUsers"
            /></span>
            <span class="value" style="width: 130px" v-else>{{
              drawerData.visitUsers
            }}</span>
            <span class="edit" @click="edit">{{ flag ? "确认" : "修改" }}</span>
          </div>
        </el-col>
        <el-col :span="11">
          <div class="visit-record-content-item">
            <span class="title">参加人员:</span>
            <span class="value"
              >{{ drawerData.registeredUserName }},{{
                drawerData.accompanyUserNames
              }}</span
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="visit-record-content2">
      <div class="q-and-a">
        <div class="question">一、面访了解事实</div>
        <div class="answer">
          <el-input
            type="textarea"
            :style="{ height: '100%' }"
            autosize
            v-model="drawerData.first"
            @blur="componentsOperation"
          ></el-input>
        </div>
      </div>
      <div class="q-and-a">
        <div class="question">
          二、面访后梳理结果（客户痛点，想要解决什么问题）
        </div>
        <div class="answer">
          <el-input
            type="textarea"
            :style="{ height: '100%' }"
            autosize
            v-model="drawerData.second"
            @blur="componentsOperation"
            @keyup.enter.native="handleEnter"
          ></el-input>
        </div>
      </div>
      <div class="q-and-a">
        <div class="question">
          三、客户第一诉求是什么？（最想要第一想解决什么问题，有什么其他诉求）
        </div>
        <div class="answer">
          <el-input
            type="textarea"
            :style="{ height: '100%' }"
            autosize
            v-model="drawerData.third"
            @blur="componentsOperation"
            @keyup.enter.native="handleEnter"
          ></el-input>
        </div>
      </div>
      <div class="q-and-a">
        <div class="question">
          四、后期如何跟进（是否有合规意向，如何跟进，时间节点）
        </div>
        <div class="answer">
          <el-input
            type="textarea"
            :style="{ height: '100%' }"
            autosize
            v-model="drawerData.fourthly"
            @blur="componentsOperation"
            @keyup.enter.native="handleEnter"
          ></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    drawerData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      flag: false,
    };
  },
  methods: {
    edit() {
      this.flag = !this.flag;
      if (!this.flag) {
        this.componentsOperation();
      }
    },
    componentsOperation() {
      this.$emit("componentsOperation", {
        value: this.drawerData,
        model: "visitRecord",
      });
    },
    handleEnter(event) {
      // event.target.blur(); // 直接让输入框失去焦点
    },
  },
  mounted() {
    console.log("drawerData", this.drawerData);
  },
};
</script>

<style scoped lang="less">
.visit-record {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
  .visit-record-content {
    text-align: left;
    .visit-record-content-item {
      display: flex;
      align-items: baseline;
      margin-bottom: 10px;
      padding: 0 5px;
      box-sizing: border-box;
      .title {
        margin-right: 5px;
        white-space: nowrap;
      }
      .value {
        input {
          width: 125px;
          border: 1px solid #dcdfe6;
          color: #2c3e50;
          font-size: 14px;
          font-family: Avenir, Helvetica, Arial, sans-serif;
        }
        input:focus {
          outline: none;
          border: 1px solid #dcdfe6;
          border-radius: 3px; /* 设置圆角 */
          font-size: 14px;
          color: #2c3e50;
          font-family: Avenir, Helvetica, Arial, sans-serif;
        }
      }
      .edit {
        color: #409eff;
        margin-left: 5px;
        cursor: pointer;
      }
    }
  }
  .visit-record-content2 {
    margin-top: 20px;
    .q-and-a {
      margin-bottom: 10px;
      .question {
        font-size: 14px;
      }
      .answer {
        /deep/ .el-textarea__inner {
          border: 0 !important;
          color: #2c3e50;
          font-family: Avenir, Helvetica, Arial, sans-serif;
          background-color: #f2f6fc;
        }
      }
    }
  }
}
</style>
